import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { getMe, logoutApi } from "@/lib/api";

const AuthContext = createContext(null);

export const login = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + window.location.pathname;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const qc = useQueryClient();

  const checkAuth = useCallback(async () => {
    try {
      setUser(await getMe());
    } catch {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    await logoutApi().catch(() => {});
    localStorage.removeItem("gh-chat-sid");
    setUser(null);
    qc.invalidateQueries();
  };

  const signedIn = (u) => {
    setUser(u);
    qc.invalidateQueries();
  };

  return <AuthContext.Provider value={{ user, loading, logout, signedIn }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
